import gql from 'graphql-tag';
import { OrganizationId } from '@kaizenplatform/intelligence-entity';
import GraphQLClient from '../../adapter/GraphQLClient';
import sleep from '../../utility/sleep';
import CustomReport from '../../entity/CustomReport';
import ChartGroup from '../../entity/ChartGroup';

class CustomReportWebApi {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public customReport = async (organizationId: OrganizationId): Promise<CustomReport | null> => {
    const result = await this.graphqlClient.query(
      gql`
        query customReport($organizationId: ID!) {
          customReport(organizationId: $organizationId) {
            id
            groups {
              name
              charts
              breakdowns {
                type
                label
                value
              }
            }
          }
        }
      `,
      {
        organizationId,
      },
    );

    if (result.status === 404) {
      return null;
    }

    return CustomReport.fromJSON(result.customReport);
  };

  public customReportStub = async (): Promise<CustomReport> => {
    await sleep(2000);
    return new CustomReport({
      id: '1',
      groups: [
        new ChartGroup({ name: 'Chart Group1', charts: ['77', '78'], breakdowns: [] }),
        new ChartGroup({ name: 'Chart Group2', charts: ['79', '80'], breakdowns: [] }),
      ],
    });
  };
}

export default CustomReportWebApi;
